import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/UI/Icon';

import './LoadingRipple.css';

const LoadingRipple = ({ text }) => (
  <div className="loading-ripple">
    <Icon icon="ripple" height="40px" width="40px" />
    <div>{text}</div>
  </div>
);

LoadingRipple.propTypes = {
  text: PropTypes.string,
};

LoadingRipple.defaultProps = {
  text: '',
};

export default LoadingRipple;
